export enum SogDataLabelValueType {
  String = "String",
  Date = "Date",
  DateTime = "DateTime",
  Money = "Money",
}
